var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStop(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 7,
    cy: 7,
    r: 7,
    fill: "#CE1717"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.08398 8.94442V5.05554C4.08398 4.78817 4.17926 4.55938 4.36982 4.36915C4.56037 4.17891 4.78917 4.08364 5.05621 4.08331H8.9451C9.21246 4.08331 9.44141 4.17859 9.63197 4.36915C9.82253 4.5597 9.91764 4.7885 9.91732 5.05554V8.94442C9.91732 9.21178 9.8222 9.44074 9.63197 9.6313C9.44174 9.82185 9.21278 9.91697 8.9451 9.91665H5.05621C4.78885 9.91665 4.56005 9.82153 4.36982 9.6313C4.17959 9.44107 4.08431 9.21211 4.08398 8.94442Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStop);
export default __webpack_public_path__ + "static/media/stop.c5ba6c5c744de26c8c3921806abad1ec.svg";
export { ForwardRef as ReactComponent };